<template>
  <footer class="app-footer">
    <!-- <span class="ml-auto">Fusion © {{ getCurrentYear }}</span> -->
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue